import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { ApplicantService, RecentlyViewedApplicant, RecentlyViewedApplicantsResponse } from "../applicant.service";
import { PortalUserService } from "@aifs-shared/portal/portal-user-service";
import { Subject, takeUntil } from "rxjs";
import { CfProfileComponent } from "@ui/cf-profile/cf-profile.component";

@Component({
    selector: 'app-recently-viewed',
    templateUrl: './recent-applicants.component.html',
    styleUrls: ['./recent-applicants.component.scss', '../../ui/cf-status-display/cf-status-display.component.scss'],
    imports: [CommonModule, CfProfileComponent],
    standalone: true,
})
export class RecentlyViewedApplicantsComponent {
    @Input() showEmail = false;

    userService = inject(PortalUserService);
    applicantService = inject(ApplicantService);

    ngOnInit() {
        this.loadRecentlyViewed();
    }

    loadRecentlyViewed(): void {
        const user = this.userService.getUser();
        if (!user) return;

        this.applicantService
            .getRecentlyViewedApplicants(user.userId)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe({
                next: (response: RecentlyViewedApplicantsResponse) => {
                    this.recentlyViewedApplicants = response.applicantsViewed || [];
                },
                error: (error: any) => {
                    console.error('Error loading recently viewed:', error);
                }
            });
    }

    selectRecentlyViewed(applicant: RecentlyViewedApplicant): void {
        if (applicant.applicationId) {
            const url = `/applicant/${applicant.applicantId}/${applicant.applicationId}`;
            window.open(url, '_blank');
        } else {
            const url = `/applicant/${applicant.applicantId}`;
            window.open(url, '_blank');
        }
    }

    getStatusClass(userState: string): string {
        const statusClass = this.applicantService.getStateDisplayClass(userState);
        // Handle the case where the service returns an object instead of string (bug in service)
        return typeof statusClass === 'string' ? `status ${statusClass}` : 'status defaultStatus';
    }

    recentlyViewedApplicants: RecentlyViewedApplicant[] = [];
    private unsubscribe = new Subject<void>();
}